// Formata telefone brasileiro
export function formatPhone(phone) {
  if (!phone) return ''
  const cleaned = phone.replace(/\D/g, '')
  if (cleaned.length === 11) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`
  }
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`
  }
  return phone
}

// Formata distância em km
export function formatDistance(meters) {
  if (!meters) return '--'
  return `${(meters / 1000).toFixed(1)} km`
}

// Formata duração em minutos
export function formatDuration(seconds) {
  if (!seconds) return '--'
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes} min`
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  return `${hours}h ${mins}min`
}

// Formata moeda BRL
export function formatCurrency(value) {
  if (value == null) return ''
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

// Trunca texto
export function truncate(text, length = 50) {
  if (!text) return ''
  if (text.length <= length) return text
  return `${text.slice(0, length)}...`
}

// Capitaliza primeira letra
export function capitalize(text) {
  if (!text) return ''
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
}

// Gera iniciais do nome
export function getInitials(name) {
  if (!name) return ''
  return name
    .split(' ')
    .map((n) => n.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('')
}
